// 画布每次移动间隔
export const moveSpace = 50

// 操作点大小
export const cornerSize = 6

// 方框的边框大小
export const rectStrokeWidth = 3

// 截图方框的边框大小
export const cutRectStrokeWidth = 1.5